import utils from '@eitje/utils'
import _ from 'lodash'
import {date} from '@eitje/utils'
import {DateRangeActiveRecord} from './active_record/base'

const TRANSLATE_TYPE = {bijzonder_verlof: 'special_leave', verlof: 'leave', ziek: 'sick'}

class Shift extends DateRangeActiveRecord {
	exported() {
		return this.exported_count > 0
	}

	dateAtEnd() {
		return this.dateRange.end.format()
	}

	allDates() {
		return [this.date, this.dateAtEnd()]
	}

	_date() {
		return date(this.date)
	}

	isOnDate(date) {
		return this.date === date.format()
	}

	isApproved() {
		return this.isReg() && this.published
	}

	started() {
		return date() > this.dateRange.start
	}

	isReg() {
		return this.tableName == 'timeRegistrationShifts'
	}

	isPlan() {
		return this.tableName == 'planningShifts'
	}

	startTime() {
		return this.dateRange.start.format('HH:mm')
	}

	rawEndTime() {
		return this.dateRange.end.format('HH:mm')
	}

	durationString({isHours} = {}) {
		return `${this.startTime()} - ${this.endTime({isHours})}`
	}

	totalGrossMins() {
		if (!this.end_date) return 0
		return this.dateRange.diff('minutes')
	}

	totalMins() {
		if (!this.end_date) return 0
		return this.dateRange.diff('minutes') - this.breakTime()
	}

	totalMinsString() {
		return utils.minToTimeString(this.totalMins())
	}

	formatDate(format) {
		return this._date().format(format)
	}

	checkInTime() {
		const {checkIns = []} = this
		return checkIns.map(c => c.totalMins()).sum()
	}

	breakTime() {
		const _breakTime = this.pauze_duur || 0
		if (_.isString(_breakTime)) return utils.timeStringToMin(_breakTime)
		return _breakTime
	}

	startsInFuture() {
		return this.dateRange.start > date()
	}

	endTime({isHours} = {}) {
		if (this.indefinite?.() && !isHours) return '?'
		return this.rawEndTime()
	}

	breaktimeString() {
		return utils.minToTimeString(this.pauze_duur) || '00:00'
	}

	isImproductive() {
		return null // time reg shift implements this
	}

	relevantForWage() {
		return true
	}

	isCheckIn() {
		return this.tableName == 'checkIns'
	}

	// WATCH OUT: THIS HAS BEEN CHANGED IN COMPARISON TO WEB, TO SUPPORT ENGLISH ONLY FOR THE MOBILE APP
	// TODO: moeten uiteindelijk nog supporten dat je de substatussen "geef tijden door" en "te laat om
	// door te geven" kunt gebruiken... willen we dat hier in de regStatus kwijt, of juist iets anders,
	// zodat de consumers van regStatus hier geen last van hebben?
	regStatus() {
		if (this.isCheckIn()) return 'check_in'
		if (!this.isReg()) return 'open'
		if (this.isImproductive()) return TRANSLATE_TYPE[this.typ]
		return this.published ? 'worked' : 'in_progress'
	}

	notWorked() {
		return this.isApproved() && this.totalMins() === 0
	}

	hasTradeRequest() {
		return this.startsInFuture?.() && this.trade_request_id
	}

	actualSkillSetId() {
		return this.skill_set_id || this.user?.skill_set_ids?.[0]
	}

	editableByWriter() {
		return !this.published || this.isPlan?.()
	}
}

export default Shift
